module.exports = __webpack_public_path__ + "img/060-businessman.f30ac520.png";